import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config';

type GlobalWithMsal = typeof globalThis & {
  __gbaMsalInstance__?: PublicClientApplication;
};

const globalWithMsal = globalThis as GlobalWithMsal;

export const msalInstance =
  globalWithMsal.__gbaMsalInstance__ ??
  (globalWithMsal.__gbaMsalInstance__ = new PublicClientApplication(
    msalConfig,
  ));
